import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useBszFinderContext } from "../../context/bszContext";
import AddRoomDialog from "./AddRoomDialog";
import BszSubjectsDialog from "./BszSubjectsDialog";
import BszSubjectsAdminDialog from "./BszSubjectsAdminDialog";
import BszClassesDialog from "./BszClassesDialog";
import BszClassesAdminDialog from "./BszClassesAdminDialog";

export default function BSZDialogs({ dialogs, actions }) {
  const { isATeacher } = useAppContext();
  const {
    isBszAdmin,
    showSubjectsDialog,
    setShowSubjectsDialog,
    showSubjectAdminDialog,
    setShowSubjectAdminDialog,
    showClassesDialog,
    setShowClassesDialog,
    showClassesAdminDialog,
    setShowClassesAdminDialog,
  } = useBszFinderContext();

  return (
    <>
      <AddRoomDialog
        open={dialogs.createRoomOpen}
        onClose={dialogs.closeRoomDialog}
        onSave={(data) => actions.handleSaveRoom(data, dialogs.closeRoomDialog)}
        initialData={dialogs.editingRoom}
      />

      {isATeacher && (
        <BszSubjectsDialog
          open={showSubjectsDialog}
          onClose={() => setShowSubjectsDialog(false)}
        />
      )}

      {isBszAdmin && (
        <BszSubjectsAdminDialog
          open={showSubjectAdminDialog}
          onClose={() => setShowSubjectAdminDialog(false)}
        />
      )}

      <BszClassesDialog
        open={showClassesDialog}
        onClose={() => setShowClassesDialog(false)}
      />

      {isBszAdmin && (
        <BszClassesAdminDialog
          open={showClassesAdminDialog}
          onClose={() => setShowClassesAdminDialog(false)}
        />
      )}
    </>
  );
}
